var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h6', {
    staticClass: "card-header"
  }, [_vm._v("Call Patching :")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 col-md-10 col-lg-10"
  }, [_c('div', {
    staticClass: "search_barT"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('label', [_vm._v("Shipping ID :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control input_field_style",
    attrs: {
      "type": "text",
      "id": "ShippingID",
      "name": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.MakeCall()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group ",
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optNumberType),
      expression: "optNumberType"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "optNumberType",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.optNumberType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.optNumberType = "1"
      }
    }
  }), _vm._v("Primary\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo.")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optNumberType),
      expression: "optNumberType"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "optNumberType"
    },
    domProps: {
      "checked": _vm._q(_vm.optNumberType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.optNumberType = "2"
      }
    }
  }), _vm._v("Alternate\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "btn btn-success",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": '#/callpatching'
    },
    on: {
      "click": function($event) {
        _vm.makecalltest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" Call\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v("   \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": '#/callpatching'
    },
    on: {
      "click": function($event) {
        _vm.ClearData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Clear ")])])])])])])])])])])]), _vm._v(" "), _vm._m(0)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "color": "red"
    }
  }, [_c('h6', {
    staticClass: "card-header"
  }, [_vm._v("Instructions :")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('ul', [_c('li', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v("Ensure your Mobile No. is registered to use Logistics call patching\n\t\t\t\t\t\t\t\t\tpanel.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v("Enter customer's Shipping Id and select \"Primary No.\" or \"Alternate\n\t\t\t\t\t\t\t\t\tNo.\" option to contact\n\t\t\t\t\t\t\t\t\tcustomer.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v("Click on \"Call\" button and wait for an incoming call on your mobile\n\t\t\t\t\t\t\t\t\tfrom \"020-67294200\"\n\t\t\t\t\t\t\t\t\t(Check your mobile network if you don't receive a call).")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v("Answer the call, and you will be connected to customer shortly.")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "card-text"
  }, [_vm._v("For queries contact Tech support team.")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31116812","hasScoped":true}!./src/views/components/callpatching/callpatching.component.html
// module id = 881
// module chunks = 1